export default {
  noStarredSources: {
    title: 'No starred sources',
    subtitle: "You haven't starred any sources yet",
    button: 'See all sources'
  },
  bookmarkButton: {
    removeFromStarred: 'Remove from starred',
    addToStarred: 'Add to starred',
    starredOnly: 'Starred only',
    showAll: 'Show all'
  }
}
